<template>
  <div
    class="formulationRow"
    @click.prevent="openDetailPage">
    <div class="ce-col ce-col-formulationName">
      <div>
        <a :href="link">
          {{ row.title }}
        </a>

        <fa-icon
          v-if="isInternal"
          transform="up-6 shrink-4"
          icon="lock" />
      </div>

      <div class="formulationRow-industries">
        {{ industriesLabel }}
      </div>
    </div>

    <div class="ce-col ce-col-actionsAfter">
      <FavoriteAction
        :shade="shade"
        :formulation="row" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FavoriteAction from 'components/formulation-repo/FavoriteAction.vue';

export default {
  props: {
    row: {
      type: Object,
      required: true,
    },
    shade: {
      type: Object,
      required: true,
    }
  },
  components: { FavoriteAction },
  computed: {
    ...mapState('generic', ['links', 'industries']),
    ...mapState('user', ['activeUser']),
    ...mapGetters('user', ['token']),
    link() {
      if (this.row.link) {
        return this.row.link;
      }

      return `${this.links.formulationRepositoryPage}${this.row.id}`;
    },
    industriesLabel() {
      if (this.row.industries) {
        if (this.industries.length === this.row.industries.length) {
          return this.$t('formulationRepository.allIndustries');
        }

        return this.industries.filter((ind) => this.row.industries.includes(ind.code)).map((ind) => ind.title).join(', ');
      }

      return null;
    },
    isInternal() {
      return this.row.acl.code === 'internal';
    }
  },
  methods: {
    openDetailPage() {
      location.href = this.link;
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.formulationRow {
  display: flex;
  padding: @space-3 @space-2;
  transition: all 250ms ease-in-out;
  border-bottom: 1px solid @color-mono-92;
  .ms(-1);
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: @color-mono-80;
  }

  .ce-col-shadeName {
    width: 24px !important;
    flex: none !important;

    @media screen and (min-width: @breakpoint-sm) {
      width: 140px !important;
    }
  }

  .ce-col-formulationName {
    a {
      color: inherit;
    }
  }

  .ce-col-actionsAfter {
    button {
      padding: @space-2;
      position: relative;
      top: -@space-2;

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &:not(.disabled):hover {
        color: @color-main;
      }
    }
  }

  .formulationRow-industries {
    .ms(-2);
    .ce-colorTextMuted;
    margin-top: calc(@space-1 / 2);
    font-style: italic;
  }
}
</style>
